import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/lab/Alert";
import {
	Button,
	Collapse,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { SimplePasswordControl } from "../controls";
import { MESApiService } from "../services";

export function ChangePassword(props: any) {
	const { onClose, userId, open } = props;
	//states
	const [password, setPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = React.useState("");
	const [canChange, setCanChange] = React.useState(false);
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);
	//functions
	const handleCancel = () => {
		onClose(false);
	};
	const handleOk = () => {
		if (userId >= 0) {
			const apiService = new MESApiService();
			apiService.changePassword(userId, password).then((response) => {
				if (apiService.hasErrors) {
					setShowError(true);
					setError(apiService.error);
				} else {
					onClose(true);
				}
			});
		} else {
			onClose(false);
		}
	};
	//effects
	React.useEffect(() => {
		setCanChange(password === confirmPassword && password.length > 0);
	}, [password, confirmPassword]);
	React.useEffect(() => {
		setPassword("");
		setConfirmPassword("");
	}, [userId, open]);

	return (
		<Dialog
			onClose={() => {}}
			aria-label={"Change Password"}
			maxWidth="xs"
			aria-labelledby="confirmation-dialog-title"
			open={open}
		>
			<DialogTitle id="confirmation-dialog-title">
				{"Change Password"}
			</DialogTitle>
			<DialogContent dividers>
				<Collapse in={showError}>
					<Alert
						severity="error"
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								size="small"
								onClick={() => {
									setShowError(false);
									setError(undefined);
								}}
							>
								<CloseIcon fontSize="inherit" />
							</IconButton>
						}
					>
						<strong>There was an error</strong>
						<p>
							{error === undefined
								? "There was an error"
								: error.internalError.message === undefined
									? error.internalError
									: error.internalError.message}
						</p>
					</Alert>
				</Collapse>
				<div className="row">
					<div className="col-md-12 px-3 py-1">
						<SimplePasswordControl
							title="Password"
							styleLabel={{ minWidth: "150px" }}
							onChange={setPassword}
							name="password"
							value={password}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12 px-3 py-1">
						<SimplePasswordControl
							title="Confirm Password"
							styleLabel={{ minWidth: "150px" }}
							onChange={setConfirmPassword}
							name="confirmPassword"
							value={confirmPassword}
						/>
					</div>
				</div>
			</DialogContent>
			<DialogActions>
				<Button autoFocus onClick={handleCancel} color="primary">
					Cancel
				</Button>
				<Button onClick={handleOk} color="primary" disabled={!canChange}>
					Change Password
				</Button>
			</DialogActions>
		</Dialog>
	);
}
